import React from "react";
import styled from "styled-components";

const SUGGESTIONS = [
  "How many cameras are currently online vs offline?",
  "Which sites have the most incidents this week, and how many are Critical?",
  "What is the people count trend for the last 7 days across all ROIs?",
  "Which companion devices are offline and how many cameras are affected by each?",
];

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  margin-top: 24px;
  max-width: 700px;
`;

const Chip = styled.button`
  padding: 12px 16px;
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 20px;
  font-size: 16px;
  color: #6b7280;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    border-color: #cd040b;
    background-color: #fff8f8;
  }
`;

export default function SuggestionChips({ onSelect }) {
  return (
    <Container>
      {SUGGESTIONS.map((text) => (
        <Chip key={text} onClick={() => onSelect(text)}>
          {text}
        </Chip>
      ))}
    </Container>
  );
}
